<app-select [required]="required" [optionsProvider]="getSources()" [(ngModel)]="value" dataKey="code"
            [formatter]="providerFormatter" (ngModelChange)="writeValue($event)" [disabled]="disabled"></app-select>
